import ViewTypes from './ViewTypes'
import SummaryPos from './SummaryPos'

export default {
    schedulerWidth: '80%',
    besidesWidth: 0,
    tableHeaderHeight: '5rem',
    schedulerMaxHeight: '36rem',

    /** Vue type jour */ 
    // Largeur de la colonne des salles
    dayResourceTableWidth: '20%',
    // Largeur des cellules dans la table
    dayCellWidth: '3.33%',
    
    /** Vue type semaine */ 
    // Largeur de la colonne des salles
    weekResourceTableWidth: '19.5%',
    // Largeur des cellules dans la table (5.75 * 14 demi-journée = 80.5 → 80.5 + 19.5 = 100%)
    weekCellWidth: '5.75%',

    /** Vue type mois */ 
    // Largeur de la colonne des salles
    monthResourceTableWidth: '20%',
    // Largeur des cellules dans la table
    monthCellWidth: '7%',

    dayMaxEvents: 99,
    weekMaxEvents: 99,
    monthMaxEvents: 99,

    eventItemHeight: 22, // Hauteur d'une div de réservation
    eventItemLineHeight: 30, // Hauteur des lignes des tables
    resourceItemLineHeight : 32, // Hauteur d'une ligne de type de salle / salle

    nonAgendaSlotMinHeight: 0,
    dayStartFrom: 0,
    dayStopTo: 23,
    defaultEventBgColor: '#80C5F6',
    selectedAreaColor: '#7EC2F3',
    summaryColor: '#666',
    summaryPos: SummaryPos.TopRight,
    groupOnlySlotColor: '#F8F8F8',

    startResizable: true,
    endResizable: true,
    movable: true,
    creatable: true,
    crossResourceMove: true,
    checkConflict: false,
    scrollToSpecialMomentEnabled: true,
    eventItemPopoverEnabled: true,
    calendarPopoverEnabled: true,
    recurringEventsEnabled: true,
    headerEnabled: true,
    displayWeekend: true,
    relativeMove: true,
    defaultExpanded: true,

    resourceName: 'Resource Name',
    taskName: 'Task Name',
    agendaViewHeader: 'Agenda',
    addMorePopoverHeaderFormat: 'MMM D, YYYY dddd',
    nonAgendaDayCellHeaderFormat: 'ha',
    nonAgendaOtherCellHeaderFormat: 'dddd|DD/MM', // Redéfini dans App.js

    minuteStep: 30,

    views: [
        {viewName: 'Day', viewType: ViewTypes.Day, showAgenda: false, isEventPerspective: false},
        {viewName: 'Week', viewType: ViewTypes.Week, showAgenda: false, isEventPerspective: false},
        {viewName: 'Month', viewType: ViewTypes.Month, showAgenda: false, isEventPerspective: false},
        {viewName: 'Quarter', viewType: ViewTypes.Quarter, showAgenda: false, isEventPerspective: false},
        {viewName: 'Year', viewType: ViewTypes.Year, showAgenda: false, isEventPerspective: false},
    ],
    
    //************* Rubriques non utilisées ***************/
    // Pas de différenciation de couleurs selons les jours
    nonWorkingTimeHeadColor: '#999999',
    nonWorkingTimeHeadBgColor: '#fff0f6',
    nonWorkingTimeBodyBgColor: '#fff0f6',
    // Données dont les types de planning ne sont pas utilisés
    quarterResourceTableWidth: 160,
    yearResourceTableWidth: 160,
    customResourceTableWidth: 160,
    agendaResourceTableWidth: 160,
    agendaMaxEventWidth: 100,
    quarterCellWidth: 80,
    yearCellWidth: 80,
    customCellWidth: 80,
    quarterMaxEvents: 99,
    yearMaxEvents: 99,
    customMaxEvents: 99,
    // *************************************************** /
    
}
